export default __webpack_public_path__ + "static/media/unstaking-step-three-bnb-mist.353b664d.png";